export default __webpack_public_path__ + "static/streamlining-operations-through-integrated-system-management-8b9d3317825c5fe39508e62239fec215.png";